module.exports = "<p>hc-measure works!</p>\n"